import React from "react"

class ErrorBoundary extends React.Component {
   constructor(props) {
      super(props)
      this.state = { hasError: false }
   }

   static getDerivedStateFromError() {
      return { hasError: true }
   }

   componentDidCatch(error, errorInfo) {
      console.error("ErrorBoundary caught an error:", error, errorInfo)
   }

   render() {
      if (!this.state.hasError) return this.props.children

      return (
         <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: "2rem", textAlign: "center" }}>
            <h1 style={{ fontSize: "1.5rem", marginBottom: "1rem", color: "#333" }}>Something went wrong</h1>
            <p style={{ marginBottom: "1.5rem", color: "#666" }}>An unexpected error occurred. Please try reloading the page.</p>
            <button
               onClick={() => window.location.reload()}
               style={{ padding: "0.75rem 1.5rem", fontSize: "1rem", backgroundColor: "#0772B6", color: "#fff", border: "none", borderRadius: "8px", cursor: "pointer" }}
            >
               Reload Page
            </button>
         </div>
      )
   }
}

export default ErrorBoundary
